export default function (method, timeInMs) {
    return setInterval(method, timeInMs);
}
